/**
 * Écart du cadre d'application au-dessus du contenu (essai TEC-1956), publié par le layout sur `:root` (0 hors
 * cadre). Un écran en pleine hauteur le retire de la sienne, comme le bandeau d'impersonation.
 */
export const APP_FRAME_GAP_PROPERTY = '--app-frame-gap'

export const APP_FRAME_GAP = `var(${APP_FRAME_GAP_PROPERTY}, 0px)`
